import React, { useState } from 'react'
import { Row, Col, Divider } from 'antd';
import { Button, DataRow, Drawer, Icon } from 'Common/components';
import { ContentArea } from "Layout_v1";
import { mongoToDate } from 'Common/scripts/Functions';
import Notes from 'Modules/Notes';
import { defaultDateTimeFormat } from 'configs';
import { TheField } from '../Components'
import { FORM_KEY } from '.';
import Client_form from 'Modules/Clients/Client_form';
import { __yellow } from 'Common/scripts/consoleHelper';
import { useHistory } from 'react-router-dom';
import { CSVLink, CSVDownload } from "react-csv";



const FormsDataView = ({ data }) => {
    const [showClientForm, set_showClientForm] = useState(false);
    let history = useHistory();

    if (!data?._id) return null;

    function getField(_fieldname){
        return data?.fields?.find(o => o.name === _fieldname) || null;
    }

    const onAdd = (values) => {
        console.log(__yellow("onAdd()"))
        history.push(`/admin/clients/${values._id}`);
    }

    const onShowFormClick = () => {
        let initialValues = { }

        data.fields.forEach(field => {
            Object.assign(initialValues, { [field.name]: field.value })
        });

        set_showClientForm(initialValues)
    }

    // return <div>Hellow orld</div>
    // console.log("data: ", data)

    const csvHeader = [
        { label: "Client company", key: "client_compnay_name" },
        { label: "Client phone", key: "client_phone" },
        { label: "Client email", key: "client_email" },
        { label: "Contact person", key: "contact_person" },
        { label: "Contact email", key: "contact_email" },
        { label: "Contact primary number", key: "contact_pri_name" },
        { label: "Contact alternate number", key: "contact_alt_name" },
        { label: "Contact primary contact method", key: "contact_preff_method" },
        { label: "Emergency name", key: "emergency_name" },
        { label: "Emergency phone", key: "emergency_phone" },
        { label: "Emergency email", key: "emergency_email" },
        
        { label: "Static guard service", key: "service_static" },
        { label: "Static guard service rate", key: "service_static_rate" },
        
        { label: "Patrol guard service", key: "service_patrol" },
        { label: "Patrol guard service rate", key: "service_patrol_rate" },
        
        { label: "Move In/Out service", key: "service_patrol" },
        { label: "Move In/Out service rate", key: "service_patrol_rate" },
        
        { label: "Firewatch service", key: "service_patrol" },
        { label: "Firewatch service rate", key: "service_patrol_rate" },
        
        { label: "Service Instructions", key: "sec_req_instructions" },
        { label: "Washroom availability", key: "have_washroom" },
        { label: "Lunch-room availability", key: "have_lunchroom" }
    ]
    
    const ExportCsvExample = ({ formData }) => {
        const csvRow = csvHeader.reduce((row, header) => {
            const matchedField = formData.find((item) => item.name === header.key);
            row[header.key] = matchedField?.value ?? "";
            return row;
        }, {});

        const csvData = [csvRow];

        return (<CSVLink
                data={csvData}
                headers={csvHeader}
                filename="client-input.csv"
            >
                <span style={{ fontSize: '16px', padding: "10px 5px", border: "1px solid #EEE", borderRadius: "5px" }}>Download CSV <Icon icon="file-csv" size="1x" /></span>
            </CSVLink>
        );

    };

    const renderSites = (_data) => {
        // console.log("siteData: ", _data)
        if (!_data || !_data.value) return <p>No sites found!!</p>;
        
        // return <p>Hello orld 1</p>
        let siteData = JSON.parse(_data.value)
        if (!siteData || !siteData.length) return <p>No site Info found!</p>

        // return <p>hello world</p>


        return siteData.map((site, i) => {
            return (<div key={i} style={{ border:"1px solid #000000", padding:"5px", marginBottom:"5px", borderRadius:"5px" }}>
                <Row>
                    <Col span={12}><b>Name: </b>{site.name}</Col>
                    <Col span={12}><b>Address: </b>{site.address}</Col>
                    <Col span={12}><b>Billing Name: </b>{site.billing_name}</Col>
                    <Col span={12}><b>Billing Address: </b>{site.billing_address}</Col>
                    <Col span={12}><b>Have washroom: </b>{site.have_washroom ? 'YES' : 'NO'}</Col>
                    <Col span={12}><b>Have lunchroom: </b>{site.have_lunchroom ? 'YES' : 'NO'}</Col>
                    <Col span={12}><b>Entry code: </b>{site.entry_code}</Col>
                    <Col span={12}><b>Lock box code: </b>{site.lockbox_code}</Col>
                    
                    <Col span={24}><Divider>Services required</Divider></Col>
                    <Col span={12}><b>Patrol Guard: </b>{site.patrol_guard ? 'YES' : 'NO'}</Col>
                    <Col span={12}><b>Static Guard: </b>{site.static_guard ? 'YES' : 'NO'}</Col>
                    <Col span={12}><b>Move Guard: </b>{site.move_guard ? 'YES' : 'NO'}</Col>
                    <Col span={12}><b>Firewatch Guard: </b>{site.firewatch_guard ? 'YES' : 'NO'}</Col>
                </Row>
                {/* <DataRow col1='Name' col2={`${site.name}`} inline size='25%' /> */}
                {/* <DataRow col1='Address' col2={`${site.address}`} inline size='25%' /> */}

                {/* <DataRow col1='Billing name' col2={`${site.billing_name}`} inline size='25%' />
                <DataRow col1='Billing address' col2={`${site.billing_address}`} inline size='25%' /> */}

                {/* <DataRow col1='Site have washroom' col2={`${site.have_washroom}`} inline size='25%' />
                <DataRow col1='Site have lunch-room' col2={`${site.have_lunchroom}`} inline size='25%' /> */}

                {/* <DataRow col1='Entry Code' col2={`${site.entry_code}`} inline size='25%' />
                <DataRow col1='Lockbox Code' col2={`${site.lockbox_code}`} inline size='25%' /> */}

                {/* <DataRow col1='Patrol guard service' col2={`${site.patrol_guard}`} inline size='25%' />
                <DataRow col1='Static guard service' col2={`${site.static_guard}`} inline size='25%' />
                <DataRow col1='Move In/Out service' col2={`${site.move_guard}`} inline size='25%' />
                <DataRow col1='Firewatch service' col2={`${site.firewatch_guard}`} inline size='25%' /> */}
            </div>)
        })
    }

    // data.fields.map(o => o.name == csvHeader.find(oo=>oo.key)?.key)

    // const csvData = [];
    // csvData.concat(data.fields.map(o=>(o.)))

    // const csvColumns = ['client_compnay_name', 'client_phone', 'client_email',
    //         'contact_person', 'contact_email', 'contact_pri_name', 'contact_alt_name', 'contact_preff_method',
    //         'emergency_name', 'emergency_phone', 'emergency_email',
    //         'service_static', 'service_static_rate', 'service_patrol', , 'service_patrol_rate', 'sec_req_instructions',
    //         'have_washroom', 'have_lunchroom', 'how_did_you_hear', 'sec_compnay_worked_with', 'sec_compnay_details', 'additional_comments'];

    // const _csvData = [
    //     [...csvColumns]
    // ]
    // _csvData = _csvData.concat(data.fields.map(o => ([o.f_name || "", o.m_name || "", o.l_name || "", o.email, o.phone || "", o.security_license_no || "", o.status])));

    return (<>
        <ContentArea transparent style={{ margin: "0" }}><Row style={{ flexWrap: "nowrap" }} gutter={[15]}>
            <Col flex="auto" className='form-data'><ContentArea style={{ margin: "0" }}>
                <Row>
                    {/* <Col flex="auto"><Button onClick={() => onShowFormClick()} size="small">Create client account from this application</Button></Col> */}
                    <Col flex="auto">
                        <ExportCsvExample formData={data.fields} />
                        {/* <CSVLink 
                            data={csvData} 
                            headers={csvHeader}
                            filename='client_input.csv'><span style={{ fontSize: '16px', padding: "10px 5px", border: "1px solid #EEE", borderRadius: "5px" }}>Download CSV <Icon icon="file-csv" size="1x" /></span></CSVLink> */}
                    </Col>
                    <Col><span style={{ color: '#999', fontSize: "12px" }}>{mongoToDate(data.created_at).format(defaultDateTimeFormat)}</span></Col>
                </Row>

                <p style={{ width: "100%", fontSize: "30px", textAlign: "center", textTransform: "capitalize", color: "#2F2F2F", fontWeight: "bold" }}>{data.title}</p>
                {/* <div style={{ height:"30px" }} /> */}

                <h4 style={{ marginTop:"20px", marginBottom:"0px" }}>Client Information</h4>
                <TheField {...getField('client_name')} size={['25%']} horizontal />
                <TheField {...getField('client_compnay_name')} size={['25%']} horizontal />
                <TheField {...getField('client_phone')} size={['25%']} horizontal />
                <TheField {...getField('client_email')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Client Contact Person</h4>
                <TheField {...getField('contact_person')} size={['25%']} horizontal />
                <TheField {...getField('contact_email')} size={['25%']} horizontal />
                <TheField {...getField('contact_pri_name')} size={['25%']} horizontal />
                <TheField {...getField('contact_alt_name')} size={['25%']} horizontal />
                <TheField {...getField('contact_preff_method')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Site Information</h4>
                {/* <TheField {...getField('sites')} size={['25%']} horizontal /> */}
                {renderSites(data.fields.find(o=>o.name==='sites'))}
                {/* <TheField {...getField('site_address_street')} size={['25%']} horizontal />
                <TheField {...getField('site_address_unit')} size={['25%']} horizontal />
                <TheField {...getField('site_address_city')} size={['25%']} horizontal />
                <TheField {...getField('site_address_state')} size={['25%']} horizontal />
                <TheField {...getField('site_address_zip')} size={['25%']} horizontal />
                <TheField {...getField('site_address_country')} size={['25%']} horizontal /> */}

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Billing Address (if different from above)</h4>
                <TheField {...getField('bil_add_street')} size={['25%']} horizontal />
                <TheField {...getField('bil_add_city')} size={['25%']} horizontal />
                <TheField {...getField('bil_add_state')} size={['25%']} horizontal />
                <TheField {...getField('bil_add_zip')} size={['25%']} horizontal />
                <TheField {...getField('bil_add_country')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Emergency Contact Information</h4>
                <TheField {...getField('emergency_name')} size={['25%']} horizontal />
                <TheField {...getField('emergency_phone')} size={['25%']} horizontal />
                <TheField {...getField('emergency_email')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Security Requirements</h4>
                {/* <Row>
                    <Col span={12}><TheField {...getField('service_static')} size={['25%']} horizontal /></Col>
                    <Col>{data?.fields?.find(o => o.name === 'service_static_rate')?.value}</Col>
                </Row> */}
                <TheField {...getField('service_static')} size={['25%']} 
                    value_postfix={data?.fields?.find(o => o.name === 'service_static')?.value === 'yes' && `@ ${data?.fields?.find(o => o.name === 'service_static_rate')?.value}`} 
                    horizontal
                />
                <TheField {...getField('service_patrol')} size={['25%']} 
                    value_postfix={data?.fields?.find(o => o.name === 'service_patrol')?.value === 'yes' && `@ ${data?.fields?.find(o => o.name === 'service_patrol_rate')?.value}`} 
                    horizontal
                />
                <TheField {...getField('service_move')} size={['25%']} 
                    value_postfix={data?.fields?.find(o => o.name === 'service_move')?.value === 'yes' && `@ ${data?.fields?.find(o => o.name === 'service_move_rate')?.value}`} 
                    horizontal
                />
                <TheField {...getField('service_firewatch')} size={['25%']} 
                    value_postfix={data?.fields?.find(o => o.name === 'service_firewatch')?.value === 'yes' && `@ ${data?.fields?.find(o => o.name === 'service_firewatch_rate')?.value}`} 
                    horizontal
                />
                {/* <Row>
                    <Col span={12}><TheField {...getField('service_patrol')} size={['25%']} horizontal /></Col>
                    <Col>{data?.fields?.find(o => o.name === 'service_patrol_rate')?.value}</Col>
                </Row> */}
                {/* <TheField {...getField('service_patrol')} size={['25%']} horizontal />
                <TheField {...getField('service_patrol_rate')} size={['25%']} horizontal /> */}
                
                <hr />
                <TheField {...getField('sec_req_type')} size={['25%']} horizontal />
                <TheField {...getField('sec_req_num_guards')} size={['25%']} horizontal />
                <TheField {...getField('sec_req_shift_schedule')} size={['25%']} horizontal />
                <TheField {...getField('sec_req_location')} size={['25%']} horizontal />
                <TheField {...getField('sec_req_purpose')} size={['25%']} horizontal />
                <TheField {...getField('sec_req_instructions')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Additional Information</h4>
                <TheField {...getField('have_washroom')} size={['25%']} horizontal />
                <TheField {...getField('have_lunchroom')} size={['25%']} horizontal />
                <TheField {...getField('how_did_you_hear')} size={['25%']} horizontal />
                <TheField {...getField('sec_compnay_worked_with')} size={['50%']} horizontal />
                <TheField {...getField('sec_compnay_details')} size={['25%']} horizontal />

                <h4 style={{ marginTop: "20px", marginBottom: "0px" }}>Additional Comments or Questions</h4>
                <TheField {...getField('additional_comments')} size={['25%']} horizontal />


                <hr style={{ margin: "50px" }} />
                {data.signature && <div align="center" style={{ padding:"40px" }}><img src={data.signature} /></div>}

            </ContentArea></Col>
            <Col flex="400px"><ContentArea style={{ margin: "0" }}><Notes id={data._id} formkey={FORM_KEY} /></ContentArea></Col>
        </Row></ContentArea>


        <Client_form onAdd={onAdd}
            showDrawer={showClientForm !== false} initialValues={showClientForm} onClose={() => set_showClientForm(false)} />

    </>)



}
export default FormsDataView;